import { render, staticRenderFns } from "./OwLayout.vue?vue&type=template&id=4de43763&scoped=true&"
import script from "./OwLayout.vue?vue&type=script&lang=js&"
export * from "./OwLayout.vue?vue&type=script&lang=js&"
import style0 from "./OwLayout.vue?vue&type=style&index=0&id=4de43763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de43763",
  null
  
)

export default component.exports